import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import IndexBannerSection from '~/components/Tools/CalculateMaximumMortgage/IndexBannerSection';
import IndexCallToActionSection from '~/components/Tools/CalculateMaximumMortgage/IndexCallToActionSection';
import IndexFaqSection from '~/components/Tools/CalculateMaximumMortgage/IndexFaqSection';
import IndexMortgageTypesSection from '~/components/Tools/CalculateMaximumMortgage/IndexMortgageTypesSection';
import SimpleLayout from '~/layouts/SimpleLayout';
import {
  CalculateMaximumMortgageSchema,
  type CalculateMaximumMortgageFormValues,
} from '~/pages/Tools/CalculateMaximumMortgage/Index/schema';

export type CalculateMaximumMortgageIndexProps = {
  totalOffices: number;
};

export const CalculateMaximumMortgageIndex: React.FC<
  CalculateMaximumMortgageIndexProps
> = ({ totalOffices }) => {
  const form = useForm<CalculateMaximumMortgageFormValues>({
    resolver: zodResolver(CalculateMaximumMortgageSchema),
    defaultValues: {
      income: undefined,
      age: undefined,
    },
  });

  return (
    <SimpleLayout>
      <FormProvider {...form}>
        <IndexBannerSection />
        <IndexFaqSection />
        <IndexMortgageTypesSection />
        <IndexCallToActionSection totalOffices={totalOffices || 6600} />
      </FormProvider>
    </SimpleLayout>
  );
};
